export var POPUP_FIELD_SIZE = 5;
export var POPUP_INPUT_SIZE = 6;
